<template>
  <div>
    <!-- //卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter='20'>
        <el-col :span='7'>
          <el-input
            placeholder='请输入文本名称'
            v-model='queryInfo.query'
            clearable
            @clear='getDataList'
          >
            <el-button
              slot='append'
              icon='el-icon-search'
              @click='getDataList'
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span='4'>
          <el-button type='primary' @click='addDialogVisible = true'
            >添加数据</el-button
          >
        </el-col>
      </el-row>

      <!-- 数据列表区域 -->
      <el-table :data='dataList' stripe>
        <el-table-column type='index'></el-table-column>
        <el-table-column label='显示文本' prop='content'></el-table-column>
        <el-table-column label='跳转地址' prop='url'></el-table-column>
        <el-table-column label='导航层级' prop='navLevel'></el-table-column>
        <el-table-column label='父级ID' prop='parentId'></el-table-column>
        <el-table-column label='优先级' prop='priority'></el-table-column>
        <el-table-column label='创建人' prop='createBy'></el-table-column>
        <el-table-column label='创建时间' prop='createTime'></el-table-column>
        <el-table-column label='操作'>
          <template slot-scope='scope'>
            <!-- 修改按钮 -->
            <el-button
              type='primary'
              icon='el-icon-edit'
              size='mini'
              @click='showEditDialog(scope.row.id)'
              style="padding: 7px 12px;"
              >修改
            </el-button>
            <!-- 删除按钮 -->
            <el-button
              type='danger'
              icon='el-icon-delete'
              size='mini'
              @click='removeById(scope.row.id)'
              style="padding: 7px 12px;"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        layout='total, prev, pager, next, jumper'
        :total='total'
      >
      </el-pagination>
    </el-card>

    <!-- 添加数据的提示框 -->
    <el-dialog
      title='添加路由配置'
      @close='addDialogClosed'
      :visible.sync='addDialogVisible'
      width='30%'
    >
      <!-- 内容主体区 -->
      <el-form :model='addForm' :rules='addFormRules' ref='addFormRef'>
        <el-form-item label='显示文本：' prop='content'>
          <el-input v-model='addForm.content'></el-input>
        </el-form-item>
        <el-form-item label='跳转地址：' prop='url'>
          <el-input v-model='addForm.url'></el-input>
        </el-form-item>
        <el-form-item label='导航层级：' prop='navLevel'>
          <el-input v-model='addForm.navLevel'></el-input>
        </el-form-item>
        <el-form-item label='父级：' prop='parentId'>
          <!-- 下拉框 -->
          <el-select v-model='addForm.parentId'>
            <el-option
              v-for='item in selectData'
              :key='item.id'
              :label='item.content'
              :value='item.id'
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='优先级：' prop='priority'>
          <el-input v-model='addForm.priority'></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot='footer' class='dialog-footer'>
        <el-button type='primary' @click='addData'> 确 定</el-button
        ><el-button @click='addDialogVisible = false'>取 消</el-button>
      </span>
    </el-dialog>

    <!-- 修改数据的对话框 -->
    <el-dialog
      title='修改数据'
      :visible.sync='editDialogVisible'
      width='30%'
      @close='editDialogClosed'
    >
      <el-form
        :model='editForm'
        :rules='addFormRules'
        ref='editFormRef'
        label-width='70px'
      >
        <el-form-item label='显示文本：' prop='content'>
          <el-input v-model='editForm.content'></el-input>
        </el-form-item>
        <el-form-item label='跳转地址：' prop='url'>
          <el-input v-model='editForm.url'></el-input>
        </el-form-item>
        <el-form-item label='导航层级：' prop='navLevel'>
          <el-input v-model='editForm.navLevel'></el-input>
        </el-form-item>
        <el-form-item label='父级：' prop='parentId'>
          <!-- 下拉框 -->
          <el-select v-model='editForm.parentId'>
            <el-option
              v-for='item in selectData'
              :key='item.id'
              :label='item.content'
              :value='item.id'
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='优先级：' prop='priority'>
          <el-input v-model='editForm.priority'></el-input>
        </el-form-item>
      </el-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='editDialogVisible = false'>取 消</el-button>
        <el-button type='primary' @click='editUserInfo'>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
export default {
  data () {
    return {
      // 数据列表
      dataList: {
        content: '',
        url: '',
        navLevel: '',
        parentId: '',
        priority: '',
        createBy: '',
        createTime: ''
      },
      // 查询信息
      queryInfo: {
        query: ''
      },
      currentPage: 1, // 默认显示第一页
      pageSize: 10, // 默认每页显示10条
      total: '',
      // 控制添加数据对话框
      addDialogVisible: false,
      // 表单验证
      addFormRules: {
        content: [
          { required: true, message: '请输入显示文本', trigger: 'blur' },
          {
            min: 3,
            max: 15,
            message: '数据名的长度在3-15个字符之间',
            trigger: 'blur'
          }
        ],
        url: [
          { required: true, message: '请输入跳转地址', trigger: 'blur' },
          {
            min: 6,
            message: '跳转地址的长度在6-15个字符之间',
            trigger: 'blur'
          }
        ],
        navLevel: [
          { required: true, message: '请输入导航层级', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请输入父级ID', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入优先级', trigger: 'blur' }
        ]
      },
      // 添加的数据信息
      addForm: {
        content: '',
        url: '',
        navLevel: '',
        parentId: '',
        priority: ''
      },
      // 添加的数据信息
      selectData: [],
      // 控制修改数据对话框的显示
      editDialogVisible: false,
      // 查询到的数据信息对象
      editForm: {
        content: '',
        url: '',
        navLevel: '',
        parentId: '',
        priority: '',
        id: 0
      },
      // 需要被分配角色的数据信息
      userInfo: {}
    }
  },
  created () {
    this.getDataList()
    this.getSelectList()
  },
  methods: {
    async getDataList () {
      const { data: res } = await this.$http.post('/navigation/list', {'currentPage': this.currentPage, 'pageSize': this.pageSize, 'body': {name: this.queryInfo.query}})
      if (res.code !== 1) {
        return this.$message.error('获取数据列表失败！')
      }
      this.dataList = res.body.data
      this.total = res.body.count
      console.info('======================dataList')
      console.info(this.dataList)
    },
    // 监听页码改变
    handleSizeChange (val) {
      this.pageSize = val // 动态改变
      this.getDataList()
    },
    handleCurrentChange (val) {
      this.currentPage = val // 动态改变
      this.getDataList()
    },
    // 监听对话框的关闭
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮添加数据
    addData () {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        // 可以发起添加数据的网络请求
        const { data: res } = await this.$http.post(
          '/navigation/insert',
          {
            content: this.addForm.content,
            url: this.addForm.url,
            navLevel: this.addForm.navLevel,
            parentId: this.addForm.parentId,
            priority: this.addForm.priority
          }
        )
        if (res == null) {
          this.$message.error('添加数据失败！')
        }
        this.$message.success('添加数据成功！')
        // 隐藏添加数据的对话框
        this.addDialogVisible = false
        // 重新获取数据列表
        this.getDataList()
      })
    },
    // 展示编辑数据的对话框
    async showEditDialog (id) {
      const { data: res } = await this.$http.post(
        '/navigation/details',
        { id: id }
      )
      if (res == null) {
        return this.$message.error('查询数据信息失败!')
      }
      this.editForm = res
      this.editDialogVisible = true
    },
    // 监听修改数据对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改数据信息并提交
    editUserInfo () {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        // 发起修改信息的数据请求
        const { data: res } = await this.$http.post(
          '/navigation/update',
          {
            content: this.editForm.content,
            url: this.editForm.url,
            navLevel: this.editForm.navLevel,
            parentId: this.editForm.parentId,
            priority: this.editForm.priority,
            id: this.editForm.id
          }
        )
        if (res == null) {
          return this.$message.error('更新数据信息失败！')
        }
        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getDataList()
        // 提示修改成功
        this.$message.success('更新数据信息成功！')
      })
    },
    // 根据id删除数据
    async removeById (id) {
      // 弹窗询问数据是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该数据, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)
      // 如果数据确认删除，则返回值为字符串confirm
      // 如果数据了取消了删除，则返回值为字符串 cancel
      // 所以可以考返回值判断数据是否删除
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post(
        '/navigation/delete',
        qs.stringify({ id: id })
      )
      if (res == null) {
        return this.$message.error('删除数据失败')
      }
      this.$message.success('删除数据成功')
      this.getDataList()
    },
    async getSelectList () {
      const { data: res } = await this.$http.post('/navigation/tree', {})
      this.selectData = res.body
      this.total = this.dataList.length
      console.info('======================selectData')
      console.info(this.dataList)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/navigat/list.vue